import React from "react"

import { Action, ActionGroup } from "shared/types/Action"
import { WithClassName } from "shared/types/WithClassName"

import { ActionsOverlayView } from "./ActionsOverlayView"
import { useActionsOverlayViewModel } from "./model/useActionsOverlayViewModel"

export interface ActionsOverlayProps extends WithClassName {
  id: string
  actions: (Action | ActionGroup)[]
  headline: string
  onCancel: () => void
}

export const ActionsOverlay = React.memo(
  ({ id, actions, headline, className, onCancel }: ActionsOverlayProps) => (
    <ActionsOverlayView
      className={className}
      {...useActionsOverlayViewModel({ id, headline, actions, onCancel })}
    />
  )
)
